var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8389 7.48926L14.4268 11.7637L15.7979 7.65527L15.8535 7.48926L15.7979 7.32324L14.4268 3.21387L20.8389 7.48926Z",
    fill: "#D7E0FF",
    stroke: "#347462",
    strokeWidth: 1.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.789062 7.48951H15.0922M13.4479 13.0503L21.7891 7.48951L13.4479 1.92871L15.3022 7.48951L13.4479 13.0503Z",
    stroke: "#347462",
    strokeWidth: 1.575,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.7c5530bc71becde3b33b39c400b50dac.svg";
export { ForwardRef as ReactComponent };